import { atom } from "recoil"

export const AtomCurrentBadge3Name = atom({
    key:'ATOMCURBADGENAME3',
    default:''
})
  